import React, { Component } from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";

export default class MoreInfo extends Component {
  render() {
    if (this.props.type === "question") {
      return (
        <OverlayTrigger
          trigger={this.props.showOn}
          placement="top"
          overlay={
            <Popover>
              <Popover.Content>{this.props.children}</Popover.Content>
            </Popover>
          }
        >
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            more info
          </a>
        </OverlayTrigger>
      );
    } else {
      return (
        <OverlayTrigger
          trigger={this.props.showOn}
          placement="top"
          overlay={
            <Popover>
              <Popover.Content>{this.props.message}</Popover.Content>
            </Popover>
          }
        >
          {this.props.children}
        </OverlayTrigger>
      );
    }
  }
}
